import { render, staticRenderFns } from "./GenericMovieList.vue?vue&type=template&id=04be05c8&scoped=true"
import script from "./GenericMovieList.vue?vue&type=script&lang=js"
export * from "./GenericMovieList.vue?vue&type=script&lang=js"
import style0 from "./GenericMovieList.vue?vue&type=style&index=0&id=04be05c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04be05c8",
  null
  
)

export default component.exports